
import React, { useState, useRef, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./responsive-tabs.scss";
import { rgba } from "polished";
import { IconMenuVertical } from "Icons";
import styled from "styled-components";
import TabTails from "./TabTails";

const StyledTabs = styled.div`
  .react-tabs {
    .react-tabs__tab--selected {
      color: ${({ theme }) => theme.primary};
      border-color: ${({ theme }) => theme.primary};
      border-bottom: 3px solid ${({ theme }) => rgba(theme.primary, 0.8)};
    }
    .react-tabs__tab--disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
    .react-tabs__tab-list {
      display: flex;
      cursor: pointer;
      border-bottom: 3px solid #ddd;
    }
  }
`;

const StyledTabsContent = styled.div`
  .react-tabs {
    .react-tabs__tab--selected  {
      color: black;
      border-color: ${({ theme }) => rgba(theme.primary, 0.8)};
      background-color: ${({ theme }) => rgba(theme.primary, 0.2)};
      display: flex;
      justify-content: center;
      border-bottom: 4px solid ${({ theme }) => rgba(theme.primary, 0.8)};
      // padding: 10px;
      gap: 7px;
    }
      .react-tabs__tab{
      height:4rem;
      gap: 7px;
      }
    .react-tabs__tab-list {
      display: flex;
      cursor: pointer;
      border-bottom: 3px solid #ddd;
    }
  }
`;

const StyledPreviewDescriptionTab = styled.div`
  .class {
    .react-tabs {
      .react-tabs__tab--selected  {
        color: ${({ theme }) => theme.primary};
        border-color: ${({ theme }) => theme.primary};
      }
    }
  }
`;

const StyledCourseTabs = styled.div`
  .react-tabs {
  .react-tabs__tab-list{
  display:flex;
  }
    .react-tabs__tab--selected {
      color: ${({ theme }) => theme.primary};
      // border-color: ${({ theme }) =>theme.primary};   //disabled fro ai course
      display: flex;
      justify-content: center;
    }
  }
`;

const ResponsiveTabs = (props) => {
  const scrollContainerRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(0);
  const StyledTab = StyledTabs;
  const StyledDescriptionTab = StyledPreviewDescriptionTab;

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        setScrollLeft((prevScrollLeft) => prevScrollLeft + evt.deltaY);
      });
    }
  }, [scrollContainerRef]);

  if (props.fromMultiPreview) {
    return (
        <StyledDescriptionTab className={props.tight && "tab-size-tight"}>
          <Tabs forceRenderTabPanel={true} selectedIndex={props.selectedIndex} onSelect={props.onChange}>
                          <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
          <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
        </div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
        </StyledDescriptionTab>
    );
  } else if (props.fromModuleForm) {
    return (
        <StyledTabsContent className={props.fromModuleForm && "tab-size-tight"}>
          <TabTails
            isQuestionSelectModal={props.isQuestionSelectModal}
          />
     <Tabs forceRenderTabPanel={true} selectedIndex={props.selectedIndex} onSelect={props.onChange}>
                    <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
</div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
        </StyledTabsContent>
    );
  } 
  else if (props.fromZonePage) {
    return (
        <StyledTabs className={props.tight && "tab-size-tight"}>
          {window.screen.width > 768 &&
            <TabTails
              fromZonePage={props.fromZonePage}
              fromVieerForm={props.fromViewerForm}
            />}
         <Tabs forceRenderTabPanel={true}>
                        <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
</div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
        </StyledTabs>
    );
  } else if (props.fromsubscribtionPreview || props.fromChapterInner || props.fromZonePage || props.fromViewerForm) {
    return (
      <StyledTab className={props.tight && "tab-size-tight"}>
        {(props.fromZonePage || props.fromViewerForm) &&
          <TabTails
            fromZonePage={props.fromZonePage}
            fromViewerForm={props.fromViewerForm}
          />}
        <Tabs forceRenderTabPanel={true} onSelect={props.onChange}>
                        <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
</div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
      </StyledTab>
    );
  } else if (props.isCourse) {
    return (
      <StyledCourseTabs className={"tab-size-tight2"}>
        <TabTails
          isQuestionSelectModal={props.isQuestionSelectModal}
        />
        <Tabs forceRenderTabPanel={true} onSelect={props.handleTabChange} >
                        <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
</div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}      
      </Tabs>
      </StyledCourseTabs>
    )
  } 
  else if (props.teacherAnalytics || props.classAnalytics) {
  return (
    <StyledTab>
      <Tabs forceRenderTabPanel={true} selectedIndex={props.selectedIndex} onSelect={props.onChange}>
        <div
          ref={scrollContainerRef}
          style={{
            overflowX: "auto",
            overflowY: "hidden",
            width: "100%",
          }}
        >
          <TabList>
            {props.items.map((item) => {
              return <Tab disabled={item.disabled}>{item.label}</Tab>;
            })}
          </TabList>
        </div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
    </StyledTab>
  );
}
  else {
    return(
    <StyledTab>
      <Tabs forceRenderTabPanel={true}>
                      <div
      ref={scrollContainerRef}
      style={{
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
      }}
    >
        <TabList>
          {props.items.map((item) => {
            return <Tab disabled={item.disabled}>{item.label}</Tab>;
          })}
        </TabList>
</div>
        {props.items.map((item) => {
          return <TabPanel>{item.children}</TabPanel>;
        })}
      </Tabs>
    </StyledTab>
  )
}
};

export default ResponsiveTabs;
